import { useCallback, useState } from 'react';
import { buildSlideKey } from '../helpers';

export const useSlidePreview = (slidesWithPaths: SlideWithPath[]) => {
  const [previewIndex, setPreviewIndex] = useState<number | null>(null);

  const openPreview = useCallback((index: number) => {
    setPreviewIndex(index);
  }, []);

  const openPreviewForSlide = useCallback(
    (slideId: number | string) => {
      const targetKey = buildSlideKey(slideId);
      const index = slidesWithPaths.findIndex(
        ({ slide }) => buildSlideKey(slide.SlideID) === targetKey,
      );
      if (index !== -1) setPreviewIndex(index);
    },
    [slidesWithPaths],
  );

  const closePreview = useCallback(() => setPreviewIndex(null), []);

  return { previewIndex, openPreview, openPreviewForSlide, closePreview };
};
